import BN from 'bn.js';
export const getCreateCurrencyParams = (asset, amount) => ({
    amount,
    base: 'wei',
    symbol: asset.displayTicker,
    denominator: asset.units[asset.ticker],
});
export const BLOWFISH_EVM_CHAINS = {
    avalanchec: {
        network: 'avalanche',
        chain: 'mainnet',
    },
    basemainnet: {
        network: 'base',
        chain: 'mainnet',
    },
    bsc: {
        network: 'bnb',
        chain: 'mainnet',
    },
    ethereum: {
        network: 'ethereum',
        chain: 'mainnet',
    },
    ethereumarbone: {
        network: 'arbitrum',
        chain: 'one',
    },
    matic: {
        network: 'polygon',
        chain: 'mainnet',
    },
    optimism: {
        network: 'optimism',
        chain: 'mainnet',
    },
};
// The maximum signed integer 2\^255 - 1 represented in BN.
export const MAX_INT256_SOLIDITY = new BN(2).pow(new BN(255)).subn(1);
